var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"titleWrapper"},[_c('van-image',{attrs:{"src":require('@/assets/img/log1.png')}})],1),(_vm.isShow)?_c('div',{staticClass:"loginShop"},[_c('div',{staticClass:"login"},[_c('van-form',{on:{"submit":_vm.onLogin}},[_c('van-field',{attrs:{"label":"用户名","placeholder":"请输入用户名","rules":[{ required: true, message: '*' }]},model:{value:(_vm.nameLogin),callback:function ($$v) {_vm.nameLogin=$$v},expression:"nameLogin"}}),_c('van-field',{attrs:{"type":"password","label":"密码","placeholder":"密码","rules":[{ required: true, message: '*' }]},model:{value:(_vm.passwordLogin),callback:function ($$v) {_vm.passwordLogin=$$v},expression:"passwordLogin"}}),_c('div',{staticStyle:{"margin":"16px"}},[_c('van-button',{attrs:{"round":"","block":"","type":"danger","native-type":"submit"}},[_vm._v(" 立即登录 ")])],1)],1)],1)]):_c('div',{staticClass:"register"},[_c('div',{staticClass:"login"},[_c('van-form',{on:{"submit":_vm.onRegister}},[_c('van-field',{attrs:{"name":"pattern ","label":_vm.$lang['用户名称'],"placeholder":_vm.$lang['请输入用户名称'],"rules":[
            {
              trigger: 'onBlur',
              required: true,
            },
            {
              trigger: 'onChange',
              pattern: _vm.pattern,
              message: this.$lang[
                '以字母开头，不能有特殊符号，长度限制在4-16位'
              ],
            } ]},model:{value:(_vm.userRegister),callback:function ($$v) {_vm.userRegister=$$v},expression:"userRegister"}}),_c('van-field',{attrs:{"type":"password","name":"validator","label":_vm.$lang['密码'],"placeholder":_vm.$lang['请输入密码'],"rules":[
            {
              trigger: 'onBlur',
              required: true,
            },
            {
              trigger: 'onChange',
              validator: _vm.validator,
              message: this.$lang[
                '由字母和数字组成，区分大小写，长度限制为6-12'
              ],
            } ]},model:{value:(_vm.passwordRegister),callback:function ($$v) {_vm.passwordRegister=$$v},expression:"passwordRegister"}}),_c('van-field',{attrs:{"type":"password","label":_vm.$lang['确认密码'],"placeholder":_vm.$lang['请再一次填写密码'],"rules":[
            {
              required: true,
              message: this.$lang['请再一次填写密码'],
              trigger: 'onBlur',
            } ]},model:{value:(_vm.passnewReg),callback:function ($$v) {_vm.passnewReg=$$v},expression:"passnewReg"}}),_c('van-field',{attrs:{"name":"validator1","type":"text","label":_vm.$lang['电话号码'],"placeholder":_vm.$lang['请输入电话号'],"rules":[
            {
              required: true,
              trigger: 'onBlur',
            },
            {
              trigger: 'onChange',
              validator: _vm.validator1,
              message: this.$lang['请输入正确的电话号码'],
            } ]},model:{value:(_vm.tel),callback:function ($$v) {_vm.tel=$$v},expression:"tel"}}),_c('van-field',{attrs:{"name":"validator2","label":_vm.$lang['护照号'],"placeholder":_vm.$lang['请输入护照号'],"rules":[
            {
              required: true,
              trigger: 'onBlur',
            },
            {
              trigger: 'onChange',
              validator: _vm.validator2,
              message: this.$lang['请输入正确的护照号'],
            } ]},model:{value:(_vm.value2),callback:function ($$v) {_vm.value2=$$v},expression:"value2"}}),_c('div',{staticStyle:{"margin":"16px"}},[_c('van-button',{attrs:{"round":"","block":"","type":"danger","native-type":"submit"}},[_vm._v(" "+_vm._s(this.$lang["立即注册"])+" ")])],1)],1)],1),_c('div',{staticClass:"switherWrapper"},[_c('span',[_c('i',{on:{"click":function($event){return _vm.register()}}},[_vm._v(_vm._s(_vm.$lang["已经有账号"]))])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }